import { Box, Button, Typography } from "@mui/material";
import { useGetInfluencerTypeQuery } from "lib/features/influencer/influencerService";
import { InfluencerType } from "lib/features/influencer/types";
import React from "react";

import { influencerListStyles } from "styles/RefereeDirectory/influencerList.styles";
import AllIcon from "../../assets/icons/referee_all.svg";
import AllIconFilled from "../../assets/icons/referee_all_filled.svg";
import BartenderIcon from "../../assets/icons/referee_bartender.svg";
import BartenderIconFilled from "../../assets/icons/referee_bartender_filled.svg";
import ConiergeIcon from "../../assets/icons/referee_concierge.svg";
import ConiergeIconFilled from "../../assets/icons/referee_concierge_filled.svg";
import EventPlannerIcon from "../../assets/icons/referee_eventplanner.svg";
import EventPlannerIconFilled from "../../assets/icons/referee_eventplanner_filled.svg";
import FrontDeskIcon from "../../assets/icons/referee_frontdesk.svg";
import FrontDeskIconFilled from "../../assets/icons/referee_frontdesk_filled.svg";
import HotelIcon from "../../assets/icons/referee_hotel.svg";
import HotelIconFilled from "../../assets/icons/referee_hotel_filled.svg";
import InfluencerIcon from "../../assets/icons/referee_influencer.svg";
import InfluencerIconFilled from "../../assets/icons/referee_influencer_filled.svg";
import OtherIcon from "../../assets/icons/referee_others.svg";
import OtherIconFilled from "../../assets/icons/referee_others_filled.svg";
import TaxiIcon from "../../assets/icons/referee_taxi.svg";
import TaxiIconFilled from "../../assets/icons/referee_taxi_filled.svg";
import TourIcon from "../../assets/icons/referee_tour.svg";
import TourIconFilled from "../../assets/icons/referee_tour_filled.svg";
import TravelPlannerIcon from "../../assets/icons/referee_travelplanner.svg";
import TravelPlannerIconFilled from "../../assets/icons/referee_travelplanner_filled.svg";

const iconMap = {
  1: { unfilled: ConiergeIcon, filled: ConiergeIconFilled },  
  2: { unfilled: HotelIcon, filled: HotelIconFilled },   
  3: { unfilled: FrontDeskIcon, filled: FrontDeskIconFilled },  
  4: { unfilled: EventPlannerIcon, filled: EventPlannerIconFilled },  
  5: { unfilled: BartenderIcon, filled: BartenderIconFilled },
  6: { unfilled: TourIcon, filled: TourIconFilled },  
  7: { unfilled: TravelPlannerIcon, filled: TravelPlannerIconFilled }, 
  8: { unfilled: TaxiIcon, filled: TaxiIconFilled }, 
  9: { unfilled: InfluencerIcon, filled: InfluencerIconFilled },  
  10: { unfilled: OtherIcon, filled: OtherIconFilled },
};

interface InfluencerListProps {
  handleActiveCategory: (id: number | null) => void;
  selectedInfluencer: number | null;
}

const InfluencerTypeList: React.FC<InfluencerListProps> = ({
  handleActiveCategory,
  selectedInfluencer,
}) => {
  const { data: influencers } = useGetInfluencerTypeQuery(null, {});

  return (
    <Box sx={influencerListStyles.container}>
      {influencers && influencers?.length > 0 && (
        <Box sx={influencerListStyles.buttonContainer}>
          {/* "All" Category Button */}
          <Button
            color={selectedInfluencer === null ? "primary" : "inherit"}
            onClick={() => handleActiveCategory(null)}
            sx={influencerListStyles.categoryButton}
          >
            <Box sx={influencerListStyles.categoryInnerBox}>
              {/* <AllIcon /> */}
              {selectedInfluencer == null ? (
                <img
                  src={AllIconFilled}
                  alt="category-image"
                  width={25}
                  height={25}
                />
              ) : (
                <img
                  src={AllIcon}
                  alt="category-image"
                  width={25}
                  height={25}
                />
              )}

              <Typography
                sx={{
                  ...influencerListStyles.categoryTypography,
                  color: selectedInfluencer === null ? "green" : "inherit",
                }}
              >
                All
              </Typography>
            </Box>
          </Button>

          {/* Dynamically Render Influencer Categories */}
          {influencers?.map((item: InfluencerType, index: number) => {
            const _selected = selectedInfluencer === item.id;

            const IconImage = _selected
              ? iconMap[item.id as keyof typeof iconMap]?.filled
              : iconMap[item.id as keyof typeof iconMap]?.unfilled;

            return (
              <Button
                key={index}
                color={_selected ? "primary" : "inherit"}
                onClick={() => handleActiveCategory(item?.id)}
                sx={influencerListStyles.categoryButton}
              >
                <Box sx={influencerListStyles.categoryInnerBox}>
                  <img
                    src={IconImage}
                    alt="category-image"
                    width={25}
                    height={25}
                  />
                  <Typography
                    sx={{
                      ...influencerListStyles.categoryTypography,
                      color: _selected ? "green" : "inherit",
                    }}
                  >
                    {item?.type}
                  </Typography>
                </Box>
              </Button>
            );
          })}
        </Box>
      )}
    </Box>
  );
};

export default InfluencerTypeList;